import React from 'react';
import { Container, IconButton, Link, SvgIcon } from '@material-ui/core';
import logo from '../../../assets/images/logo.png';
import { useHistory } from 'react-router-dom';
import { HOME_ROUTE } from '../../constants/route.constant';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import AndroidIcon from '@material-ui/icons/Android';
import AppleIcon from '@material-ui/icons/Apple';
import './styles.scss';

// Threads has no Material-UI v4 icon; render the official logo as an inline SVG.
const ThreadsIcon = (props: any) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.065 7.168 1.43 1.781 3.631 2.695 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L9.696 8.95c.98-1.456 2.568-2.256 4.471-2.256h.044c3.184.02 5.081 1.969 5.269 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.848 1.81-4.09 2.628-7.221 2.65Zm1.534-11.305a10.43 10.43 0 0 0-.998.048c-1.834.103-2.974.949-2.91 2.155.067 1.26 1.458 1.846 2.799 1.774 1.23-.067 2.834-.546 3.103-3.733a8.49 8.49 0 0 0-1.994-.249Z" />
  </SvgIcon>
);

export const Footer = () => {

  const history = useHistory();

  const handleLogoClick = () => {
    history.push(HOME_ROUTE.path);
  }

  return (
    <footer className='footer-section'>
      <Container>
        <div className='logo-holder'>
          <img onClick={handleLogoClick} className="img-logo" src={logo} alt="Xarothi logo" />
          <div className="img-name">Xarothi, Your Career Companion</div>
        </div>

        <nav aria-label="Footer navigation" className='links-holder'>
          <Link href="/test-series">Free Mock Tests</Link>
          <Link target="_blank" href="/about-us">About Us</Link>
          <Link target="_blank" href="/privacy-policy">Privacy Policy</Link>
          <Link target="_blank" href="/terms-and-conditions">Terms and Conditions</Link>
          <Link target="_blank" href="/terms-of-use">Terms of Use (iOS App)</Link>
          <Link target="_blank" href="/get-in-touch">Get in Touch</Link>
          <Link target="_blank" href="/work-with-us">Work with us</Link>
          <Link target="_blank" href="/refund-and-cancellation">Refund and Cancellation policies</Link>
          <Link href="/find-a-tutor-near-me">Find a Tutor</Link>
          <Link href="/become-a-tutor">Become a Tutor</Link>
        </nav>

        <div className="download-app">
          <Link href="/download" className="play-store-link">
            <AndroidIcon fontSize="small" className="store-icon" />
            <AppleIcon fontSize="small" className="store-icon" />
            Download our App
          </Link>
        </div>

        <div className="social-media-links">
          <IconButton component="a" href="https://www.facebook.com/ourxarothi/" target="_blank" rel="noopener noreferrer" aria-label="Xarothi on Facebook" size="medium">
            <FacebookIcon fontSize="inherit" className="social-icon" />
          </IconButton>
          <IconButton component="a" href="https://www.instagram.com/ourxarothi/" target="_blank" rel="noopener noreferrer" aria-label="Xarothi on Instagram" size="medium">
            <InstagramIcon fontSize="inherit" className="social-icon" />
          </IconButton>
          <IconButton component="a" href="https://www.youtube.com/@ourxarothi" target="_blank" rel="noopener noreferrer" aria-label="Xarothi on YouTube" size="medium">
            <YouTubeIcon fontSize="inherit" className="social-icon" />
          </IconButton>
          <IconButton component="a" href="https://www.threads.com/@ourxarothi" target="_blank" rel="noopener noreferrer" aria-label="Xarothi on Threads" size="medium">
            <ThreadsIcon fontSize="inherit" className="social-icon" />
          </IconButton>
        </div>

        <div className="all-rights-reserved">
          &copy; {new Date().getFullYear()} Xarothi. All rights reserved.
        </div>
      </Container>
    </footer>

  )
}
